export default __webpack_public_path__ + "static/36_months-7ed0018d952f34e6cbf1de82923c8046.jpeg";